import { connect } from 'react-redux'

import VerificationForm from 'app/session/register_components/mobile_verification_form'
import { clearError, resendOTP, verify } from 'app/session/session_actions'
import { setBackUrl } from 'app/shared_components/actions'

const mapStateToProps = ({ session, Shared }) => ({
  currentUser: session.currentUser,
  success: session.success,
  rolePromptOn: session.rolePromptOn,
  error: session.error,
  backUrl: Shared.backUrl,
})

const mapDispatchToProps = (dispatch) => ({
  resendOTP: (data) => resendOTP(data),
  verify: (data, forwardUrl) => verify(data, forwardUrl),
  clearError: () => clearError(),
  setBackUrl: (url) => dispatch(setBackUrl(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(VerificationForm)
